import { Input, TextArea } from "common/InputForm";
import useButtonLoader from "common/UseButtonLoader";
import useDebounce from "common/UseDebounce";
import { CustomButton } from "components/form";
import React, { useEffect, useMemo, useRef, useState } from "react";
import JoditEditor from "jodit-react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toastMessage } from "utils/toastMessage";
import { regex } from "utils/formValidator";
import { editPostApi, postDetailApi, postHastagListApi } from "services/post";
import { IoMdArrowRoundBack } from "react-icons/io";
import { FaImage, FaTimes } from "react-icons/fa";
import { IoCloudUploadOutline } from "react-icons/io5";
import { GoX } from "react-icons/go";

const EditPost = () => {
  const navigate = useNavigate();
  const [hashtagList, setHashtagList] = useState([]);
  const { id } = useParams();
  const [buttonLoaders, setButtonLoaders] = useButtonLoader("Save");
  const [errors, setErrors] = useState({});
  const [filteredHashtagList, setFilteredHashtagList] = useState([]);

  const { imageFileRegex, videoFileRegex } = regex;
  const [formData, setFormData] = useState({
    postId: id,
    caption: "",
    location: "",
    images: [],
    video: "",
    videoName: "",
    videoThumb: "",
    removeVideo: "",
    hashTags: "",
    removeImages: [],
    removeId: [],
  });
  console.log(formData.newVideo, "new video");
  const [videoData, setVideoData] = useState("");
  console.log(videoData, "setdatavide");
  const [search, setSearch] = useState("");
  const debouncedValue = useDebounce(search, 300);
  const editor = useRef(null);

  const [currentWord, setCurrentWord] = useState("");
  const [showSuggestions, setShowSuggestions] = useState(false);

  const config = useMemo(
    () => ({
      readonly: false,
      placeholder: "",
      toolbar: true,
      spellcheck: true,
      language: "en",
      toolbarButtonSize: "medium",
      showCharsCounter: true,
      showWordsCounter: true,
      showXPathInStatusbar: false,
      askBeforePasteHTML: false,
      askBeforePasteFromWord: false,
      uploader: { insertImageAsBase64URI: true },
      controls: {
        font: {
          command: "fontname",
          list: {
            "'Open Sans',sans-serif": "Open Sans",
            "Helvetica,sans-serif": "Helvetica",
            "Arial,Helvetica,sans-serif": "Arial",
            "Georgia,serif": "Georgia",
            "Impact,Charcoal,sans-serif": "Impact",
            "Tahoma,Geneva,sans-serif": "Tahoma",
            "'Times New Roman',Times,serif": "Times New Roman",
            "Verdana,Geneva,sans-serif": "Verdana",
            "Consolas,monospace": "Consolas",
          },
        },
      },
    }),
    []
  );

  // Fetch hashtag suggestions
  useEffect(() => {
    const fetchHashtagList = async () => {
      try {
        const res = await postHastagListApi();
        if (res?.data?.status === 200) {
          setHashtagList(res.data?.data?.hashtags || []);
        } else {
          toastMessage(res?.data?.message, "error", "hashtagList");
        }
      } catch (e) {
        toastMessage(e.message, "error", "hashtagList");
      }
    };
    fetchHashtagList();
  }, []);
  // Filter the hashtag list based on user input
  useEffect(() => {
    if (debouncedValue) {
      const filteredList = hashtagList.filter((tag) =>
        tag.title.toLowerCase().includes(debouncedValue.toLowerCase())
      );
      setFilteredHashtagList(filteredList);
    } else {
      setFilteredHashtagList([]);
    }
  }, [debouncedValue, hashtagList]);
  console.log(filteredHashtagList, "hashtaglist");

  const handleHashtagChange = (e) => {
    const value = e.target.value;
    setFormData((prev) => ({ ...prev, hashTags: value }));
    setSearch(value);
  };
  useEffect(() => {
    fetchPostDetails(id);
  }, [id]);

  const fetchPostDetails = async () => {
    try {
      const res = await postDetailApi(id);
      if (res?.data?.status === 200) {
        setFormData({
          postId: id,
          caption: res.data.data.post.caption,
          location: res.data.data.post.location,
          images: res.data.data.post.images,
          videoThumb: res.data.data.post.videoThumb,
          hashTags: res.data.data.post.hashTags,
        });
        setVideoData(res.data.data.post?.video?.url);
      } else {
        toastMessage(res?.data?.message, "error", "postDetail");
      }
    } catch (e) {
      toastMessage(e.message, "error", "postDetail");
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    if (name === "caption") {
      checkHashtag(formData?.caption);
    }
  };
  const emptyDescriptionRegex = /^<p><br><\/p>$/;
  // Handle form validation
  const validateForm = () => {
    const newErrors = {};
    if (!formData?.caption || emptyDescriptionRegex.test(formData.caption)) {
      newErrors.caption = "Caption is required";
    }
    // if (!formData.location) {
    //   newErrors.location = "Location is required";
    // }
    if (formData.newVideo && formData.images) {
      // // Enforce that only one of video or image(s) can be uploaded
      // if (formData.newVideo && formData.images && formData.images.length > 0) {
      //   newErrors.general = "You can only upload either images or a video, not both";
      // } else
      if (
        !formData.newVideo &&
        (!formData.images || formData.images.length === 0)
      ) {
        newErrors.generals = "You must upload at least one image or a video";
      }
    }
    if (formData.video && formData.images) {
      // // Enforce that only one of video or image(s) can be uploaded
      // if (formData.video && formData.images && formData.images.length > 0) {
      //   newErrors.general = "You can only upload either images or a video, not both";
      // } else
      if (
        !formData.video &&
        (!formData.images || formData.images.length === 0)
      ) {
        newErrors.generals = "You must upload at least one image or a video";
      }
    }
    console.log(newErrors, "network");
    // Add additional validation as needed
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const removeImage = (indexToRemove, id) => {
    setFormData((prevData) => {
      const updatedImages = [...prevData?.images];
      const removedImage = updatedImages?.splice(indexToRemove, 1);

      const updatedRemoveIds = id
        ? [...(prevData?.removeId || []), id]
        : [...(prevData?.removeId || [])];

      return {
        ...prevData,
        images: updatedImages,
        removeImages: [...(prevData?.removeImages || []), ...removedImage],
        removeId: updatedRemoveIds,
      };
    });
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    const validImages = files.filter((file) => imageFileRegex.test(file.name));
    if (validImages.length > 0) {
      const imagePreviews = validImages.map((file) =>
        URL.createObjectURL(file)
      );
      setFormData((prevData) => ({
        ...prevData,
        images: [...prevData?.images, ...validImages],
        removeImages: prevData.removeImages?.filter(
          (img) => !validImages.includes(img)
        ),
      }));
    }
  };

  // Handle video upload and thumbnail generation
  const handleVideoChange = (e) => {
    const file = e.target.files[0];
    if (file && videoFileRegex.test(file.name)) {
      const videoUrl = URL.createObjectURL(file);
      setFormData((prevData) => ({
        ...prevData,
        newVideo: videoUrl,
        videoName: file,
      }));
      // Generate thumbnail
      const videoElement = document.createElement("video");
      videoElement.src = videoUrl;
      videoElement.currentTime = 1;
      videoElement.onloadeddata = () => {
        const canvas = document.createElement("canvas");
        canvas.width = videoElement.videoWidth / 2;
        canvas.height = videoElement.videoHeight / 2;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(videoElement, 0, 0, canvas.width, canvas.height);
        const thumbnail = canvas.toDataURL("image/png");
        setFormData((prevData) => ({ ...prevData, videoThumb: thumbnail }));
      };
    }
  };
  const handleRemoveVideo = () => {
    console.log("remove");
    setFormData((prevData) => ({
      ...prevData,
      video: "",
      videoName: null,
      newVideo: "",
      videoThumb: "",
      removeVideo: "yes",
    }));
    setVideoData("");
  };

  console.log(formData, "onvideoformdat");
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    setButtonLoaders(true);
    try {
      const formDatas = new FormData();
      formDatas.append("postId", id);
      formDatas.append("caption", formData.caption);
      formDatas.append("location", formData.location || "");
      formDatas.append("video", formData.videoName || "");
      formDatas.append("videoThumb", formData.videoThumb || "");
      formDatas.append("removeVideo", formData.removeVideo);
      formDatas.append("hashTags", formData.hashTags || "");
      console.log(formData.images, "formData.images");
      if (formData.images && Array.isArray(formData.images)) {
        formData.images.forEach((image) => {
          formDatas.append("images", image);
        });
      }
      if (formData.removeId && Array.isArray(formData.removeId)) {
        formData.removeId.forEach((id) => {
          formDatas.append("removeImages", id);
        });
      } else {
        formDatas.append("removeImages", "");
      }
      console.log(formDatas, "fnjwdh");
      const res = await editPostApi(formDatas);
      console.log(res, "editpost");
      if (res?.data?.status === 200) {
        toastMessage(res?.data?.message, "success", "editPost");
        navigate(-1);
      } else {
        toastMessage(res?.data?.message, "error", "editPost");
      }
    } catch (e) {
      toastMessage(e.message, "error", "editPost");
    } finally {
      setButtonLoaders(false);
    }
  };

  const checkHashtag = (value) => {
    // Check if the user typed `#` or is typing a hashtag
    const words = value.split(" ");
    const lastWord = words[words.length - 1];

    if (lastWord.startsWith("")) {
      setCurrentWord(lastWord.substring(1)); // Get the word after `#`
      setFilteredHashtagList(
        hashtagList.filter((tag) =>
          tag.title.toLowerCase().includes(currentWord.toLowerCase())
        )
      );
      setShowSuggestions(true);
    } else {
      setShowSuggestions(false);
    }
  };

  const handleSuggestionClick = (suggestion) => {
    const words = formData.caption.split(" ");
    if (words?.length) {
      words[words?.length - 1] = `${suggestion}`; // Replace the current word with the selected suggestion
    }
    setFormData({ ...formData, caption: words.join(" ") });
    setShowSuggestions(false);
  };
  return (
    <div className="postManagement add">
      <div className="dashboard_title has_child">
        <h3>
          <Link to={"/post-management"}>
            <IoMdArrowRoundBack />
          </Link>{" "}
          Edit Post
        </h3>
        <CustomButton
          type="button"
          className="button"
          ref={buttonLoaders}
          onClick={handleSubmit}
        >
          Update
        </CustomButton>
      </div>
      <div className="card">
        <div className="card-body">
          <form>
            <div className="form_field_wrap">
              <div className="form_field">
                <Input
                  type="text"
                  label="Location"
                  name="location"
                  placeholder="Enter Location"
                  value={formData.location}
                  onChange={handleInputChange}
                  error={errors.location}
                />
              </div>

              <div className="form_field">
                <label className="label">Caption</label>
                {/* <JoditEditor
                ref={editor}
                value={formData.caption}
                tabIndex={1}
                onBlur={(newContent) =>
                  handleInputChange({
                    target: { name: "caption", value: newContent },
                  })
                }
                config={config}
              />
                {errors &&
                (!formData?.caption ||
                  emptyDescriptionRegex.test(formData.caption)) && (
                  <p
                    className={`${(!formData?.caption ||
                        emptyDescriptionRegex.test(formData.caption)) &&
                      "invalid-feedback d-block"
                      }`}
                  >
                    {errors.caption}
                  </p>
                )} */}
                <Input
                  value={formData?.caption}
                  error={errors.caption}
                  name="caption"
                  onChange={handleInputChange}
                />
                {showSuggestions && (
                  <ul
                    style={{
                      position: "absolute",
                      background: "white",
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                      listStyle: "none",
                      padding: "10px",
                      margin: 0,
                      top: "100%",
                      left: 0,
                      width: "100%",
                      zIndex: 10,
                    }}
                  >
                    {filteredHashtagList.map(({ title }, index) => (
                      <li
                        key={index}
                        style={{
                          padding: "5px 10px",
                          cursor: "pointer",
                          borderBottom: "1px solid #f0f0f0",
                        }}
                        onClick={() => handleSuggestionClick(title)}
                      >
                        {title}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
            <div className="form_field_wrap">
              <div className="form_field">
                <label className="label">Upload Images</label>
                <label className="file_uploader" htmlFor="upload_image">
                  <input
                    type="file"
                    accept="image/*"
                    multiple
                    onChange={handleFileChange}
                    id="upload_image"
                  />

                  {formData.images.length > 0 ? (
                    <>
                      <FaImage className="icon" />
                      <h5>Images Upload</h5>
                    </>
                  ) : (
                    <>
                      {" "}
                      <IoCloudUploadOutline className="icon" />
                      <h5>Upload Images</h5>
                    </>
                  )}
                </label>

                <div className="image_preview_wrap">
                  {formData?.images?.map((image, index) => (
                    <div key={index} className="image_preview">
                      <img
                        src={image.url ? image.url : URL.createObjectURL(image)}
                        alt={`Preview ${index}`}
                      />
                      <button
                        type="button"
                        onClick={() => removeImage(index, image?._id)}
                      >
                        <FaTimes />
                      </button>
                    </div>
                  ))}
                </div>
              </div>
              <div className="form_field position-relative">
                <label className="label">Upload Video</label>

                <label className="file_uploader" htmlFor="upload_video">
                  <input
                    type="file"
                    accept="video/*"
                    onChange={handleVideoChange}
                    id="upload_video"
                  />

                  {formData?.newVideo ? (
                    <div className="video_preview">
                      <video src={formData.newVideo} controls width="300" />
                    </div>
                  ) : (
                    <>
                      {videoData ? (
                        <div className="video_preview">
                          <video src={videoData} controls width="300" />
                        </div>
                      ) : (
                        <>
                          <IoCloudUploadOutline className="icon" />
                          <h5>Upload Video</h5>
                        </>
                      )}
                    </>
                  )}
                </label>
                {formData?.newVideo && (
                  <button
                    className="remove_video_button"
                    onClick={handleRemoveVideo}
                  >
                    <GoX />
                  </button>
                )}
                {videoData && (
                  <button
                    className="remove_video_button"
                    onClick={handleRemoveVideo}
                  >
                    <GoX />
                  </button>
                )}
              </div>
            </div>
            {errors && (
              <p className="invalid-feedback d-block">{errors.general}</p>
            )}

            {errors && (
              <p className="invalid-feedback d-block">{errors.generals}</p>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditPost;
